import { Avatar, Button, Form, Input, Modal, Select, Spin, Tag, message } from 'antd'
import { PiPaperclipThin } from "react-icons/pi";
import { BsFillSendFill } from "react-icons/bs";
import { useEffect, useRef, useState } from 'react';
import { RiGalleryLine } from "react-icons/ri";
import { IoChatbubbleOutline } from "react-icons/io5";
import { LuThumbsUp, LuThumbsDown } from "react-icons/lu";
import { dropdownService } from '../../../services';
import chatService from '../../../services/chat-service';
import { changeDocumentTitle } from '../../../utils/title';
// import echo from "../../../echo"; 
import ajaxService from "../../../services/ajax-service";

const { TextArea } = Input

const LS_KEYS = {
    CHAT_STARTED: "cs_chat_started",
    WAITING: "cs_waiting_for_agent",
    MESSAGES: "cs_messages",
    IS_CHAT_ENDED: "cs_chat_ended",
    SELECTED_ROLE: "cs_selected_role"
};

function CustomerSupport() {
   
    console.log(window.Echo);
    const [form] = Form.useForm();
    const messagesContainerRef = useRef(null);
    
    // UI state
    const [agentName, setAgentName] = useState('Live Support');
    const [chatId, setChatId] = useState(null);
    const [isChatStarted, setIsChatStarted] = useState(false);
    const [isWaitingForAgent, setIsWaitingForAgent] = useState(false); // waiting state
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [feedback, setFeedback] = useState(false);
   
    const [rating, setRating] = useState(null);
    const [isChatEnded, setIsChatEnded] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    
    // roles & loading
    const [roles, setRoles] = useState([])
    const [loadingRoles, setLoadingRoles] = useState(false)
    const [submitting, setSubmitting] = useState(false)

    // messages + input
    const [messages, setMessages] = useState(() => {
        const raw = localStorage.getItem(LS_KEYS.MESSAGES);
        return raw ? JSON.parse(raw) : [];
    });
    const [inputValue, setInputValue] = useState("");
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);
    const [remarks, setRemarks] = useState("");
    // helper: find default role id (General Inquiry or first)
    const getDefaultRoleId = () => {
        if (!roles || roles.length === 0) return null;
        const general = roles.find(r => r.name?.toLowerCase().trim() === "general inquiry");
        return (general && general.id) || roles[0].id;
    };

     /*  Message Sound  */
    const messageAudioRef = useRef(null);
    useEffect(() => {
        messageAudioRef.current = new Audio("/sounds/message.mp3");
    }, []);
    
    const playMessageSound = () => {
        messageAudioRef.current?.play().catch(() => {});
    };

    const normalizeMessages = (messages = []) => {
        return messages.map(e => {
            const time = new Date(e.created_at).toLocaleTimeString();
            
            let msgType;
            if (e.sender_type === "customer") msgType = "sent";
            else if (e.sender_type === "system") msgType = "system"; 
            else msgType = "received";

            return {
            id: e.id,
            text: e.message,
            type: msgType,
            time,
            attachment: e.attachment ?? null,
            };
        });
    };


    // Auto-scroll whenever messages change
    useEffect(() => {
        // persist messages
        try {
            localStorage.setItem(LS_KEYS.MESSAGES, JSON.stringify(messages));
        } catch (e) { /* ignore */ }

        const el = messagesContainerRef.current;
        if (!el) return;
        requestAnimationFrame(() => {
            el.scrollTop = el.scrollHeight;
        });
    }, [messages]);

    // Persist chat started & waiting & ended across refresh
    useEffect(() => {
        try {
            const started = localStorage.getItem(LS_KEYS.CHAT_STARTED) === "true";
            const waiting = localStorage.getItem(LS_KEYS.WAITING) === "true";
            const ended = localStorage.getItem(LS_KEYS.IS_CHAT_ENDED) === "true";

            setIsChatStarted(started);
            setIsWaitingForAgent(waiting);
            setIsChatEnded(ended);
           
        } catch (e) {
            // ignore parse errors
        }

        // fetch roles (needed for fallback)
        fetchRoles();
    }, []);

    // Whenever chat flags change, persist them
    useEffect(() => {
        try {
            localStorage.setItem(LS_KEYS.CHAT_STARTED, isChatStarted ? "true" : "false");
            localStorage.setItem(LS_KEYS.WAITING, isWaitingForAgent ? "true" : "false");
            localStorage.setItem(LS_KEYS.IS_CHAT_ENDED, isChatEnded ? "true" : "false");
        } catch (e) { /* ignore */ }
    }, [isChatStarted, isWaitingForAgent, isChatEnded]);


    // When user sends a message from chat input
    const handleSend = async () => {
        if (!inputValue || isChatEnded) return;

        const payload = {
            chat_request_id: chatId,
            message: inputValue,
            role_id:null
        };

        await chatService.sendMessage(chatId,payload);
        // await chatService.sendMessage(chatId, {
        //     message: inputValue,
        //     file: file,
        // });
     
        setMessages(prev => [
            ...prev,
            {
            type: "sent",
            text: inputValue,
            time: new Date().toLocaleTimeString(),
            },
        ]);

        setInputValue("");
        setFile(null);
    };

    const handleResolve = async () => {
        if (!chatId) {
            console.warn("No active chat to resolve");
            return;
        }

        await ajaxService.post(
            `/chat-requests/${chatId}/close`,
            {
            rating,
            remarks
            }
        );

        // UI cleanup
        setFeedback(false);
        // setIsChatEnded(true);
        // setIsChatStarted(false);
        // resetChatPersistence();
    };

    const handleNotNow = async () => {
          setIsModalOpen(false);
        if (!chatId) {
            console.warn("No active chat to resolve");
            return;
        }

        await ajaxService.post(
            `/chat-requests/${chatId}/close`,
            {
            rating:0,
            remarks,
            }
        );

        // UI cleanup
        setFeedback(false);
        // setIsChatEnded(true);
        // setIsChatStarted(false);
        // resetChatPersistence();
    };

    const onFinish = async (data) => {
        // produce payload with fallback role_id if none selected
        const payload = {
            ...data,
            role_id: data.role_id ?? getDefaultRoleId()
        };

        if (!payload.role_id) {
            message.error("No department available to assign (roles list empty).");
            return;
        }

        setSubmitting(true);
        try {
            const response = await chatService.addRequest(payload);
            const agentJoined = Boolean(response?.data?.agent_joined);

            if (response?.success) {
                // save chat id for echo subscription
                setChatId(response.data.id);
                message.success("Chat started successfully");
                setIsChatStarted(true);
                // setIsWaitingForAgent(!agentJoined);
                setIsWaitingForAgent(true);
                setIsChatEnded(false);

                const time = new Date().toLocaleTimeString();

                // add the user's submitted message into chat immediately
                setMessages(prev => [
                    ...prev,
                    { text: payload.message, type: "sent", pending: !agentJoined, time },
                    // system message: either joined or waiting
                    ...(agentJoined
                        ? [{ text: "Agent joined the chat.", type: "system", system: true, time }]
                        : [{ text: "Waiting for an available support agent...", type: "system", system: true, time }])
                ]);

                // reset only subject/message fields
                form.resetFields(["subject", "message"]);
                setIsButtonDisabled(true);
            } else {
                message.error(response?.message || "Failed to start chat");
            }
        } catch (err) {
            console.error("submit error", err);
            message.error("Error while submitting request");
        } finally {
            setSubmitting(false);
        }
    };

    // channels
    useEffect(() => {
        if (!chatId || !window.Echo) return;

        const channel = window.Echo.private(`chat.${chatId}`);
        
        // Agent accepted /joined chat
        channel.listen(".agent-joined", (e) => {
            const time = new Date().toLocaleTimeString();

            setIsWaitingForAgent(false);
            setAgentName(e.agent.name);

            setMessages(prev => [
                ...prev,
                {
                id:e.id,
                text: `Support agent ${e.agent.name} joined the chat.`,
                type: "system",
                system: true,
                time,
                }
            ]);

        });


        channel.listen(".chat-message", (e) => {
            
            if(e.sender_type !== "customer"){
                setMessages(prev => {
                // prevent duplicates
                if (prev.some(m => m.id === e.id)) {
                return prev;
                }

                const time = new Date(e.created_at).toLocaleTimeString();
                if(isWaitingForAgent ===true){
                    setIsWaitingForAgent(false);
                }

                  // set type based on sender_type
                let msgType;
                if (e.sender_type === "customer") msgType = "sent";
                else if (e.sender_type === "system") msgType = "system"; // NEW
                else msgType = "received";

                return [
                ...prev,
                {
                    id: e.id,
                    text: e.message,
                    type: msgType,
                    time,
                    attachment: e.attachment ?? null,
                },
                ];
            });

            playMessageSound();
            }
            
        });


        // Chat transferred
        // channel.listen(".chat-transferred", () => {
        //     const time = new Date().toLocaleTimeString();

        //     setIsWaitingForAgent(true);

        //     setMessages(prev => [
        //     ...prev,
        //     {
        //         type: "system",
        //         text: "Your chat was transferred to another support team.",
        //         time,
        //     },
        //     ]);
        // });

        channel.listen(".chat-transfering", (e) => {
            const time = new Date().toLocaleTimeString();

            setIsWaitingForAgent(true);

            setMessages(prev => [
            ...prev,
            {
                type: "system",
                text: e.message,
                time,
            },
            ]);
        });

        // Chat closed
        channel.listen(".chat-closed", (e) => {
            const time = new Date().toLocaleTimeString();

            if(e.closed_by =="customer"){
                setMessages(prev => [
                    ...prev,
                    {
                    type: "system",
                    text: "This chat has been closed by you.",
                    time,
                    },
                ]);
            }else{
                setMessages(prev => [
                    ...prev,
                    {
                    type: "system",
                    text: "This chat has been closed by support agent.",
                    time,
                    },
                ]);
            }

            setChatId(null);

            // IMPORTANT RESET AFTER SHORT DELAY
            setTimeout(() => {
                setChatId(null);          // show new chat form again
                setMessages([]);
                setFeedback(false);
                setRating(null);
                setRemarks("");

                setIsWaitingForAgent(false);
                setIsChatStarted(false);
                setAgentName("Live Support");
                resetChatPersistence();
            }, 800);
        });

        return () => {
            window.Echo.leave(`chat.${chatId}`);
        };
    }, [chatId]);


    // active chats of customers
    useEffect(() => {
        const loadActiveChat = async () => {
            try {
            const res = await ajaxService.get("/chat-requests/customer/active");
            const chatData = res?.data;

            if (!chatData) {
                setIsChatStarted(false);
                setMessages([]);
                setIsWaitingForAgent(false);
                setIsChatEnded(false);
                setChatId(null);
                return;
            }else{
                setIsChatEnded(false);
                setIsChatStarted(true);
                setChatId(chatData?.id);
                setMessages(normalizeMessages(chatData.messages));
                setAgentName(chatData?.agent?.name);
            }

           

            if (chatData.status === "new") {
                setIsWaitingForAgent(true);
                setMessages(prev => [
                    ...prev,
                    {
                        id: chatData.id,
                        text: "Waiting for an available support agent...",
                        type: "system",
                        system: true,
                        time: new Date().toLocaleTimeString(),
                    },
                ]);
                
            }

            if (chatData.status === "closed") {
                setIsChatEnded(true);
            }

            } finally {
                setLoadingRoles(false);
            }
        };

        loadActiveChat();
    }, []);

    const fetchRoles = async () => {
        setLoadingRoles(true)
        try {
            const response = await dropdownService.fetchRoles();
            if (response?.success) {
                setRoles(response.data || []);
            } else {
                // keep roles as-is if fetch failed
                message.error("Failed to load departments");
            }
        } catch (err) {
            console.error("fetchRoles error", err);
            message.error("Error loading departments");
        } finally {
            setLoadingRoles(false)
        }
    };

    const handleOk = () => {
        setIsModalOpen(false);
        setFeedback(true)
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const submitFeedback = async () => {
        if (!rating) return;

        await ajaxService.post(
            `/chat-requests/${chatId}/resolve`,
            {
            rating,
            remarks,
            }
        );

        
        setFeedback(false);
        setIsChatEnded(true);
        setIsWaitingForAgent(false);
        setChatId(null);

        setMessages(prev => [
            ...prev,
            {
            type: "received",
            text: "Thank you for your feedback!",
            time: new Date().toLocaleTimeString(),
            },
        ]);
    };

    

    // Persist or reset functions
    const resetChatPersistence = () => {
        localStorage.removeItem(LS_KEYS.CHAT_STARTED);
        localStorage.removeItem(LS_KEYS.WAITING);
        localStorage.removeItem(LS_KEYS.MESSAGES);
        localStorage.removeItem(LS_KEYS.IS_CHAT_ENDED);
    };

   

 
    // UI: Section (form) and chatBox (chat UI)
    const section = (
        <div className='p-5 bg-white' >
            <div className='text-center'>
                <h1 className='text-lg'> Thank you for choosing</h1>
                <h1 className='text-xl font-light'>Ctrade Houston</h1>
                <p className='m-0 text-base'>Let us connect you to our support agent</p>
                <p className='text-[#737373] text-base pt-1'> Let us get started, start messaging now so our agents can get back to you quickly</p>
            </div>
            <div>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    onValuesChange={() => {
                        const values = form.getFieldsValue();
                        // enable submit only when subject & message are filled
                        const allFilled = Boolean(values.subject && values.message);
                        setIsButtonDisabled(!allFilled);
                    }}
                >
                    <Form.Item
                        label="Department"
                        name="role_id"
                    >
                        <Select
                            placeholder="Select Department"
                            style={{ height: "46px" }}
                            notFoundContent={loadingRoles ? <Spin size="small" /> : "No data"}
                            loading={loadingRoles}
                            allowClear
                        >
                            {roles.map((role) => (
                                <Select.Option key={role.id} value={role.id}>
                                    {role.title}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    {/* Subject */}
                    <Form.Item
                        label="Subject"
                        name="subject"
                    >
                        <Input placeholder="Enter subject" style={{ height: "46px" }} />
                    </Form.Item>

                    {/* Message */}
                    <Form.Item
                        label="Message"
                        name="message"
                    >
                        <TextArea rows={5} placeholder="Type your message..." />
                    </Form.Item>
                    <div className='flex gap-3 items-center '>
                        <Button htmlType='submit' type='primary' disabled={isButtonDisabled || submitting}>
                            {submitting ? <><Spin size="small" /> Starting Chat...</> : "Start Chat"}
                        </Button>
                        <p className='pt-4'>Please enter subject and message to start, department defaults to General Inquiry</p>
                    </div>
                </Form>
            </div>

        </div>
    );

    const chatBox = (
        <div >
            <div className='flex  justify-between items-center border-b-2'>
                <div className='flex p-2 gap-2'>
                    <Avatar
                        size="large"
                        src={"/images/profile_image.jpg"}
                        style={{ cursor: "pointer", height: "55px", width: "55px" }}
                    />
                    <div className='flex flex-col gap-1 justify-center'>
                        <p className='m-0 text-sm'>{agentName}</p>
                        <p className='m-0 text-[#646E78] text-xs'>Customer Support</p>
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    {isWaitingForAgent ? (
                        <Tag color="orange">Waiting for agent...</Tag>
                    ) : (
                        <Tag color='green'>Online</Tag>
                    )}
                </div>
            </div>

            <div className="flex justify-center items-center p-4">
                {(!messages || messages.length === 0) ? (
                    <div className='flex justify-center items-center p-20'>
                        <div className='flex flex-col gap-4 items-center justify-center border w-[75%] bg-white p-10 rounded-lg '>
                            <p className='text-xl p-0 m-0'>Thank you for choosing</p>
                            <img src='/images/Houston.png' style={{ width: "200px", height: "64px" }} />
                            <p className='text-lg p-0 m-0'>Let’s connect you to our support agent</p>
                            <p className='italic text-sm text-center leading-8'>Let’s get started, start messaging now so our agents can get back to you quickly</p>
                        </div>
                    </div>
                ) : (
                  <div
                    className="w-full h-80 rounded-lg p-4 overflow-y-auto"
                    ref={messagesContainerRef}
                    >
                    {messages.map((msg, idx) => {
                    
                      if (msg.type === "system") {
                        return (
                        <div
                            key={idx}
                            className="flex justify-center my-3 "
                        >
                            <div className="bg-gray-100 text-gray-600 p-1 text-sm text-center border rounded-md">
                            {msg.text}
                            </div>
                        </div>
                        );
                    }
                    return(
                        <div
                        key={idx}
                        className={`flex mb-3 ${
                            msg.type === "sent" ? "justify-end" : "justify-start"
                        }`}
                        >
                        {msg.type === "received" ? (
                            <div className="flex gap-2 max-w-[75%]">
                            <Avatar  src={"/images/profile_image.jpg"} size={40}></Avatar>

                            <div className="flex flex-col">
                                {/* TEXT */}
                                {msg.text && (
                                <div className="bg-gray-100 px-4 py-2 rounded-lg text-sm">
                                    {msg.text}
                                </div>
                                )}

                                {/* IMAGE */}
                                {msg.attachment?.type === "image" && (
                                <img
                                    src={msg.attachment.url}
                                    alt={msg.attachment.name}
                                    className="mt-2 rounded-lg max-w-[220px] cursor-pointer"
                                />
                                )}

                                {/* FILE */}
                                {msg.attachment?.type === "file" && (
                                <a
                                    href={msg.attachment.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="flex items-center gap-2 mt-2 underline text-sm"
                                >
                                    📎 {msg.attachment.name}
                                </a>
                                )}

                                <p className="text-[10px] text-gray-400 mt-1">
                                {msg.time || "12:00 PM"}
                                </p>
                            </div>
                            </div>
                        ) : (
                            <div className="max-w-[70%] flex flex-col items-end">
                            {/* TEXT */}
                            {msg.text && (
                                <div
                                className={`px-5 py-2 rounded-lg text-sm shadow ${
                                    msg.system
                                    ? "bg-gray-100 text-gray-700"
                                    : "bg-primary text-white"
                                }`}
                                >
                                {msg.text}
                                {msg.pending && (
                                    <span className="text-xs ml-2">(pending)</span>
                                )}
                                </div>
                            )}

                            {/* IMAGE */}
                            {msg.attachment?.type === "image" && (
                                <img
                                src={msg.attachment.url}
                                alt={msg.attachment.name}
                                className="mt-2 rounded-lg max-w-[220px] cursor-pointer"
                                />
                            )}

                            {/* FILE */}
                            {msg.attachment?.type === "file" && (
                                <a
                                href={msg.attachment.url}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center gap-2 mt-2 underline text-sm"
                                >
                                📎 {msg.attachment.name}
                                </a>
                            )}

                            <p className="text-[10px] text-gray-300 mt-1 text-right">
                                {msg.time || "12:00 PM"}
                            </p>
                            </div>
                        )}
                        </div>
                    );
                    })}
                    </div>

                )}
            </div>

            <div className="p-2 m-1 flex gap-3 items-center  border-t-2 pt-4 ">
                {/* <div className='flex gap-3 items-center '>
                    <input
                    type="file"
                    ref={fileInputRef}
                    className="hidden"
                    accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                    onChange={e => setFile(e.target.files[0])}
                    />
                    <Button
                        type="text"
                        icon={<PiPaperclipThin style={{ fontSize: 22 }} />}
                        onClick={() => fileInputRef.current.click()}
                        />

                        <Button
                        type="text"
                        icon={<RiGalleryLine style={{ fontSize: 22 }} />}
                        onClick={() => fileInputRef.current.click()}
                        />
                </div> */}
                <Input
                    value={inputValue}
                    onPressEnter={handleSend}
                    onChange={(e) => setInputValue(e.target.value)}
                    disabled={isChatEnded || isWaitingForAgent}
                    placeholder={isWaitingForAgent ? "Waiting for agent to join..." : "Type your message here..."}
                    className="border focus:shadow-none px-2"
                    style={{ height: "46px" }}
                />

                <div className='flex gap-3 justify-end'>
                    <Button  type='primary' onClick={handleSend} disabled={isChatEnded || isWaitingForAgent} className="flex items-center justify-center px-4 py-4 text-white ">
                        <BsFillSendFill style={{ fontSize: "12px" }} /> Send
                    </Button>
                    <Button type='default' onClick={() => { setIsModalOpen(true); setIsChatEnded(true); }} className="flex items-center justify-center px-4 py-4">
                        End Chat
                    </Button>
                </div>
            </div>
        </div>
    );

    useEffect(() => {
        changeDocumentTitle("Chat Support");
    }, [])
    return (
        <>
            <div className=' bg-primary text-white p-3 text-base mb-4 rounded-xl flex justify-center gap-3' >
                <IoChatbubbleOutline style={{ fontSize: 22 }} />
                <span>Chat with our support team</span>
            </div>

            <div className='bg-[white] pb-1 rounded-xl border'>
                {(!isChatStarted)  ? section : chatBox}
            </div>

            {feedback &&
                <div className='bg-[white] pb-1 mt-4 rounded-xl border'>
                    <div className='p-5'>
                        <h2 className='text-base font-semibold mb-4'>Please rate this chat</h2>
                        <div className='flex gap-4 mb-4'>
                            <Button size='middle' type={rating === 5 ? 'primary' : 'default'} onClick={() => setRating(5)} className='text-base p-5'>
                                <LuThumbsUp style={{ fontSize: 20 }} /> Thumbs Up
                            </Button>
                            <Button type={rating === 1 ? 'primary' : 'default'} onClick={() => setRating(1)} className='text-base p-5 flex items-center'>
                                <LuThumbsDown style={{ fontSize: 19 }} /> Thumbs Down
                            </Button>
                        </div>
                        <TextArea  onChange={(e) => setRemarks(e.target.value)} rows={5} placeholder="Leave a comment(optional)..." className='mb-4' />
                        <div className='flex  gap-2'>
                            {/* <Button type='default' onClick={() => setFeedback(false)}>Skip</Button> */}
                            {/* <Button type='primary' onClick={submitFeedback}>Send</Button> */}
                            {chatId && (
                            <Button type="primary" onClick={handleResolve}>
                                Submit & Close
                            </Button>
                            )}

                        </div>
                    </div>
                </div>
            }

            <Modal title={<p className='text-lg font-semibold'>End Chat and rate Support</p>} open={isModalOpen} onCancel={handleCancel} footer={null} centered>
                <p className="text-[#808080] text-base">Would you like to leave quick feedback now?</p>
                <div className="flex justify-start gap-2">
                    <Button type="primary" onClick={handleOk}>Yes, take me to rating</Button>
                    <Button onClick={handleNotNow}>Not now</Button>
                </div>
            </Modal>
        </>
    )
}

export default CustomerSupport
